import { http } from './config'

export default {

  getOrderStepsByPalletType: (pallet_type, locality) => {
    return http.get(`/order_steps?pallet_type=${pallet_type}&locality=${locality}`)
  },

  getOrderStep: (id) => {
    return http.get(`/order_steps/${id}`)
  },
}
